import script from "./DeliveryOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliveryOrders.vue?vue&type=script&setup=true&lang=js"

import "./DeliveryOrders.vue?vue&type=style&index=0&id=13af189f&scoped=true&lang=css"

import exportComponent from "E:\\Project\\METE_OUTLET_WEB\\METE_WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13af189f"]])

export default __exports__